<template>
  <toolbar class='toolbar'>
    <toolbar-button command="undo" icon="undo"/>
    <toolbar-button command="redo" icon="redo"/>
    <toolbar-button command="copy" icon="copy"/>
    <toolbar-button command="paste" icon="paste"/>
    <toolbar-button command="delete" icon="delete"/>
    <toolbar-button command="zoomIn" icon="zoom_in_map" text="Zoom In" />
    <toolbar-button command="zoomOut" icon="zoom_out_map" text="Zoom Out" />
    <toolbar-button command="autoZoom" icon="center_focus_weak" text="Fit Map" />
    <toolbar-button command="resetZoom" icon="center_focus_strong" text="Actual Size" />
    <toolbar-button command="toBack" icon="flip_to_back" text="To Back" />
    <toolbar-button command="toFront" icon="flip_to_front" text="To Front" />
  </toolbar>
</template>

<script>
import { Toolbar } from 'vg-editor';
import ToolbarButton from './FlowToolBarButton.vue';

export default {
  name: 'FlowToolbar',

  components: {
    Toolbar,
    ToolbarButton,
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.toolbar {
  display: flex;
  align-items: center;
  height: rem(27);

  .command {
    display: inline-block;
    width: rem(27);
    height: rem(27);
    margin: 0 $space-1;
    text-align: center;
    border: $border-width-thin solid var(--bg-primary);
    cursor: pointer;
    color: var(--text-primary);

    &:hover {
      border: $border-width-thin solid var(--border-hover);
      background-color: var(--bg-tertiary);
    }
  }

  .disable {
    color: var(--text-disabled, rgba(0, 0, 0, 0.25));
    cursor: auto;

    &:hover {
      border: $border-width-thin solid var(--bg-primary);
      background-color: unset;
    }
  }
}

</style>
